module.exports = __webpack_public_path__ + "static/media/biteship-blibli.b616a2b4.png";